import { freshModal } from "../../components/freshModal";
import { Button } from "../../components/reusableComponents/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "../../components/reusableComponents/Dialog";
import { Label } from "../../components/reusableComponents/Label";
import {
  RadioGroup,
  RadioGroupItem,
} from "../../components/reusableComponents/RadioGroup";

function ClientRelanceModalFormSession({
  open,
  onOpenChange,
  niveauRelance,
  setNiveauRelance,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 overflow-hidden bg-white rounded-lg shadow-lg">
        {/* En-tête */}
        <div className="bg-gradient-to-r from-blue-700 to-blue-800 py-6 px-8">
          <DialogTitle className="text-2xl font-bold text-white">
            Niveau de relance
          </DialogTitle>
          <p className="text-blue-100 mt-1">
            Choisissez un niveau de relance pour ce client
          </p>
        </div>

        {/* Corps */}
        <div className="p-8 space-y-6">
          <RadioGroup
            value={niveauRelance.toString()}
            onValueChange={(v) => setNiveauRelance(parseInt(v))}
            className="space-y-4"
          >
            {[0, 1, 2, 3].map((n) => (
              <div
                key={n}
                className={`flex items-center p-3 rounded-md border ${
                  n === 0
                    ? "bg-white border-gray-200"
                    : n === 1
                      ? "bg-blue-50 border-blue-200"
                      : n === 2
                        ? "bg-orange-50 border-orange-200"
                        : "bg-red-50 border-red-200"
                }`}
              >
                <RadioGroupItem value={n.toString()} id={`relance-${n}`} />
                <Label htmlFor={`relance-${n}`} className="ml-2 cursor-pointer">
                  {n === 0 ? "Aucune" : `Niveau ${n}`}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>

        {/* Pied de modal */}
        <DialogFooter className="flex justify-end px-8 py-6 border-t border-gray-200 bg-gray-50">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="border-gray-300 hover:bg-gray-100"
          >
            Annuler
          </Button>
          <Button
            className="ml-3 bg-blue-700 hover:bg-blue-800 text-white"
            onClick={onSubmit}
          >
            Enregistrer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export const ClientRelanceModal = freshModal(ClientRelanceModalFormSession, "open");
